



































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CrosshairIcon,
  FilterIcon,
  SearchIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { IGoal } from 'admiral-core';
import 'dayjs/locale/de';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';

@Component({
  name: 'goals-filter',
  components: {
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CrosshairIcon,
  },
})
export default class GoalFilterComponent extends mixins(FilterMixin) {
  @Prop({ type: Array })
  selected!: IGoal[];

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  @Prop({ type: Array, default: () => [] })
  goals!: IGoal[];

  mounted() {
    //
  }

  changed(val: IGoal[]) {
    let goals = [];

    if (val.length > this.selected.length) {
      goals = val.slice(this.selected.length);
    } else if (val.length <= this.selected.length) {
      goals = val;
    }

    this.$emit('update', val);
  }
}
